import React from "react";
import PropTypes from "prop-types";

const DynamicTable = ({ data }) => {
  if (!data || data.length === 0) {
    return <p>No data available</p>;
  }

  // Extract the headers from the keys of the first object
  const headers = Object.keys(data[0]);

  return (
    <div className="table-responsive">
      <table className="table table-bordered table-striped">
        <thead className="">
          <tr>
            {headers.map((header) => (
              <th key={header}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              {headers.map((header) => (
                <td key={header}>{item[header]}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

DynamicTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default DynamicTable;
